import { render } from "./cyberDefenceHeader.vue?vue&type=template&id=1402a067"
import script from "./cyberDefenceHeader.vue?vue&type=script&lang=js"
export * from "./cyberDefenceHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sec.daragroups.com/sec.daragroups.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__